module.exports = __webpack_public_path__ + "img/t1.9112cc12.png";